export const UPDATE_SESSION = 'UPDATE_SESSION';
export const DESTROY_SESSION = 'DESTROY_SESSION';
export const CLEAR_STATE = 'CLEAR_STATE';
